import MmxApi from "../api/mmxApi";

export default {
  //Add a contact in the server
  getPersistantContacts: (server, securityToken, dispatch) => {
    const api = new MmxApi(server, securityToken, dispatch);
    return api.contacts.getPersistantContacts();
  },

  //Load contacts from server
  loadContacts: (server, securityToken, dispatch) => {
    const api = new MmxApi(server, securityToken, dispatch);
    return new Promise((resolve, reject) => {
      api.contacts
        .search("%25")
        .done(data => {
          let contacts = data.contactList.map((item, index) => {
            return { ...item };
          });
          resolve(contacts);
        })
        .fail((xhr, ajaxOptions, thrownError) => {
          reject({ xhr, ajaxOptions, thrownError });
        });
    });
  },

  //Delete a contact in the server
  delete: (id, server, securityToken, dispatch) => {
    const api = new MmxApi(server, securityToken, dispatch);
    return api.contacts.delete(id);
  },

  //Update the information of a contact in the server
  update: (data, server, securityToken, dispatch) => {
    const api = new MmxApi(server, securityToken, dispatch);
    return api.contacts.update(data);
  },

  //Add a contact in the server
  add: (data, server, securityToken, dispatch) => {
    const api = new MmxApi(server, securityToken, dispatch);
    return api.contacts.add(data);
  },
};






// WEBPACK FOOTER //
// ./src/services/contactsService.js